import mixpanel from 'mixpanel-browser';
import { BlazeMeterUser } from 'types/rest/blazeMeterApiResponse';
import { MixPanelEventType } from './mixpanelEvents';

/** True once Mixpanel has been initialised, which only happens after analytics consent. */
let initialized = false;

/**
 * Wrapper for Mixpanel calls.
 */
const MixpanelService = {
  /**
   * Initializes Mixpanel with the token.
   * @param token
   */
  init: (token: string) => {
    if (token) {
      mixpanel.init(token);
      initialized = true;
    } else {
      console.log('No mixpanel token from backend');
    }
  },

  /**
   * Push Blazemeter user to Mixpanel.
   * @param user
   */
  setUser: (user: BlazeMeterUser) => {
    mixpanel.identify(user.email);

    // Properties beginning with $ are reserved ones
    // https://help.mixpanel.com/hc/en-us/articles/115004708186-Profile-Properties

    // Mixpanel.people.set is used for user properties that won't change during the runtime
    // opposite is Mixpanel.people.register which is for properties, which might change
    mixpanel.people.set({
      $email: user.email,
      $first_name: user.firstName,
      $last_name: user.lastName,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      defaultAccountId: user.defaultAccountId,
      defaultAccountName: user.defaultAccountName,
      displayName: user.displayName,
      roles: user.roles,
    });
  },

  /**
   * Push new mixpanel event to the mixpanel.
   * @param mixpanelEvent
   * @param sendToGTM - Event gets posted to Google Tag manager
   */
  track(mixpanelEvent: MixPanelEventType, sendToGTM = false): void {
    const data = mixpanelEvent.metadata || {};
    try {
      if (initialized) {
        mixpanel.track(mixpanelEvent.event, data);
      }
      if (sendToGTM) {
        (window as any).dataLayer.push({ event: mixpanelEvent.event, ...data });
      }
    } catch (error) {
      console.error('Cannot track Mixpanel event,', mixpanelEvent);
    }
  },
};

export default MixpanelService;
